import { render, staticRenderFns } from "./openlist-dialog.vue?vue&type=template&id=f0d56ed2&scoped=true"
import script from "./openlist-dialog.vue?vue&type=script&lang=js"
export * from "./openlist-dialog.vue?vue&type=script&lang=js"
import style0 from "./openlist-dialog.vue?vue&type=style&index=0&id=f0d56ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d56ed2",
  null
  
)

export default component.exports